import { render, staticRenderFns } from "./SimpleBidsTable.vue?vue&type=template&id=e601e7c6&scoped=true"
import script from "./SimpleBidsTable.vue?vue&type=script&lang=js"
export * from "./SimpleBidsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e601e7c6",
  null
  
)

export default component.exports